import { useMsal } from "@azure/msal-react";
import { loginRequest } from "@/features/auth/authConfig";

export function LoginPage() {
  const { instance } = useMsal();

  return (
    <main className="grid min-h-screen place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-900">Sign in to Mable</h1>
        <p className="mt-2 text-slate-600">Use your Deloitte account to continue.</p>
        <button
          type="button"
          onClick={() => void instance.loginRedirect(loginRequest)}
          className="mt-6 inline-flex w-full items-center justify-center rounded-md bg-brand px-4 py-2.5 text-sm font-medium text-white transition hover:bg-brand-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
        >
          Sign in
        </button>
      </div>
    </main>
  );
}
